// @flow

import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import FooterSocial from 'components/footer/FooterSocial';
import Sidebar from 'components/sidebar/Sidebar';
import Loading from 'components/fragments/Loading';
import RencontreHeader from 'containers/rencontre/RencontreHeaderContainer';
import RencontreGeneral from 'containers/rencontre/RencontreGeneralContainer';
import RencontreStats from 'containers/rencontre/RencontreStatsContainer';
import RencontreMedias from 'containers/rencontre/RencontreMediasContainer';

import { withHelmet } from 'infrastructure/seo/Helmet';

import { handleTagEvent } from 'utils/tagManagerUtils';

import { STATUS_SUCCESS } from 'constants/statusConstants';

import type { RouterProps } from 'types/Router';
import type { RencontreType } from 'types/Rencontre';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchRencontre: (id: string, slugEquipe?: string) => void,
};

export type StateProps = {
  rencontre: ?RencontreType,
  status: Status,
  statusPage: Status,
  organization: string,
  sidebarContent: BlocContent[],
  club: string,
};

type Props = StateProps & DispatchProps & RouterProps;

class Rencontre extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    const { status, statusPage, match: { params: { rencontre_id, tab } } } = this.props;
    if (
      nextProps.status !== status ||
      nextProps.statusPage !== statusPage ||
      nextProps.match.params.rencontre_id !== rencontre_id ||
      nextProps.match.params.tab !== tab
    ) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    const { fetchPageList, fetchRencontre, match: { params: { rencontre_id, slug } } } = this.props;

    if (rencontre_id !== undefined && rencontre_id !== null && rencontre_id !== '') {
      if (slug !== undefined && slug !== null) {
        fetchRencontre(rencontre_id, slug);
      } else {
        fetchRencontre(rencontre_id);
      }
    }

    fetchPageList(slug ?? '');
  }

  clickTagManager = (socialName: string) => {
    const { match: { params: { rencontre_id } }, club } = this.props;
    return handleTagEvent(
      'partage',
      `partage_match ${rencontre_id ?? ''}`,
      club,
      () => {},
      socialName
    );
  };

  render() {
    const { rencontre, match: { path }, status, sidebarContent } = this.props;
    if (status !== STATUS_SUCCESS || !rencontre) {
      return <Loading />;
    }

    return (
      <>
        <RencontreHeader />
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <Switch>
                <Route exact path={`${path}/general`} component={RencontreGeneral} />
                <Route exact path={`${path}/statistiques-classement`} component={RencontreStats} />
                <Route exact path={`${path}/medias`} component={RencontreMedias} />
                <Route exact path={`${path}/`} component={RencontreGeneral} />
                <Route exact path={`${path}`} component={RencontreGeneral} />
                <Route render={() => <Redirect to='/404' />} />
              </Switch>
              <div className="row mt-4">
                <FooterSocial parentClass="col col-lg-7on9" clickTagManager={this.clickTagManager} />
              </div>
            </div>
            <Sidebar sidebarContent={sidebarContent || []} />
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(Rencontre)((Helmet, pageProps)  => {
  return (
    <Helmet>
      <link rel={'canonical'} href={window.location.href} />
  </Helmet>);
});
